// extracted by mini-css-extract-plugin
export var button = "_ai-7";
export var buttonRow = "_ai-6";
export var fadeIn = "_ai-1";
export var gradient = "_ai-0";
export var panel = "_ai-2";
export var panelIn = "_ai-3";
export var subtitle = "_ai-5";
export var title = "_ai-4";